export const NEXT_LANDMARK = "r";
export const PREV_LANDMARK = "q";
